/* Wild Honey — product page: gallery thumbnails, the Order-by-color steppers, and ONE cart request
   carrying every row with a quantity (POST /cart/add.js, items[]). After it lands, Dawn's cart drawer
   is re-rendered with the sections the same request returns; without a drawer the page goes to /cart. */
(function () {
  function initGallery(root) {
    var thumbs = root.querySelectorAll('[data-wh-thumb]');
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = btn.getAttribute('data-wh-thumb');
        root.querySelectorAll('[data-wh-slide]').forEach(function (s) {
          var on = s.getAttribute('data-wh-slide') === i;
          s.hidden = !on;
          s.classList.toggle('is-active', on);
        });
        thumbs.forEach(function (t) {
          var on = t === btn;
          t.classList.toggle('is-active', on);
          if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
      });
    });
  }

  function clamp(input) {
    var v = parseInt(input.value, 10);
    if (!isFinite(v) || v < 0) v = 0;
    var max = input.hasAttribute('max') ? parseInt(input.getAttribute('max'), 10) : Infinity;
    if (v > max) v = max;
    input.value = String(v);
    return v;
  }

  function initOrder(form) {
    var inputs = Array.prototype.slice.call(form.querySelectorAll('[data-wh-variant]'));
    var button = form.querySelector('[data-wh-add]');
    var label = form.querySelector('[data-wh-add-label]');
    var error = form.querySelector('[data-wh-error]');
    var busy = false;

    function total() {
      return inputs.reduce(function (n, i) { return n + clamp(i); }, 0);
    }
    function refresh() {
      var n = total();
      button.disabled = busy || n === 0;
      label.textContent = n === 0 ? 'Choose quantities above' : 'Add ' + n + (n === 1 ? ' piece' : ' pieces') + ' to cart';
    }

    form.addEventListener('click', function (e) {
      var b = e.target.closest('[data-wh-step]');
      if (!b) return;
      var input = b.parentElement.querySelector('[data-wh-variant]');
      var step = parseInt(input.getAttribute('step'), 10) || 1;
      input.value = String(clamp(input) + step * parseInt(b.getAttribute('data-wh-step'), 10));
      clamp(input);
      refresh();
    });
    inputs.forEach(function (i) { i.addEventListener('input', refresh); i.addEventListener('change', refresh); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return; // a second press while the first request is in flight adds nothing
      var items = inputs.map(function (i) { return { id: Number(i.getAttribute('data-wh-variant')), quantity: clamp(i) }; })
        .filter(function (x) { return x.quantity > 0; });
      if (!items.length) return;
      busy = true;
      refresh();
      error.hidden = true;
      var drawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer && drawer.getSectionsToRender) {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || res.j.status) {
            error.textContent = res.j.description || res.j.message || 'These pieces could not be added. Please check the quantities.';
            error.hidden = false;
            return;
          }
          inputs.forEach(function (i) { i.value = '0'; });
          if (drawer && res.j.sections) {
            var first = res.j.items && res.j.items[0];
            drawer.classList.remove('is-empty');
            drawer.renderContents(Object.assign({}, res.j, { id: first ? first.key : '' }));
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function () {
          error.textContent = 'The connection dropped. Nothing was added; please try again.';
          error.hidden = false;
        })
        .finally(function () { busy = false; refresh(); });
    });
    refresh();
  }

  function init() {
    document.querySelectorAll('[data-wh-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-wh-order]').forEach(initOrder);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
